// extracted by mini-css-extract-plugin
export default {"buttons":"style_buttons__gRtBh"};